import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Printer } from 'lucide-react';
import { shopAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { btnGhost, panelCls } from '../components/ui';

export default function Invoice() {
  const { paymentId } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    shopAPI.invoice(paymentId).then(({ data: d }) => setData(d)).catch(() => setMissing(true));
  }, [paymentId]);

  if (missing) return <p className="py-16 text-center text-sm text-lms-muted">{t('Invoice not found.')}</p>;
  if (!data) return <p className="text-sm text-lms-muted">{t('Loading…')}</p>;

  const { payment, course, buyer, brand } = data;

  return (
    <div className="mx-auto max-w-xl">
      <div className="mb-4 flex items-center justify-between print:hidden">
        <Link to="/my/purchases" className="flex items-center gap-1.5 text-sm text-lms-muted hover:text-lms-text">
          <ArrowLeft size={15} />
          {t('Purchase history')}
        </Link>
        <button onClick={() => window.print()} className={btnGhost}>
          <Printer size={14} />
          {t('Print')}
        </button>
      </div>
      <div className={`${panelCls} p-8 print:border-0 print:shadow-none`}>
        <div className="mb-8 flex items-start justify-between">
          <div>
            <div className="text-lg font-semibold">{brand.name}</div>
            <div className="text-xs text-lms-faint">{t('Invoice')}</div>
          </div>
          <div className="text-right text-xs text-lms-muted">
            <div className="lms-num">#{payment.id.slice(0, 12)}</div>
            <div className="lms-num">{(payment.created_at || '').slice(0, 10)}</div>
          </div>
        </div>
        <div className="mb-6 text-sm">
          <div className="text-xs text-lms-faint">{t('Billed to')}</div>
          <div>{buyer.name}</div>
          <div className="text-lms-muted">{buyer.email}</div>
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-lms-border text-left text-xs text-lms-faint">
              <th className="py-2 font-medium">{t('Item')}</th>
              <th className="py-2 text-right font-medium">{t('Amount')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-lms-border">
              <td className="py-3">{course.title || payment.course_id}</td>
              <td className="py-3 text-right lms-num">${Number(payment.amount).toFixed(2)}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td className="py-3 font-semibold">{t('Total')}</td>
              <td className="py-3 text-right font-semibold lms-num">
                ${Number(payment.amount).toFixed(2)} <span className="text-xs uppercase text-lms-faint">{payment.currency}</span>
              </td>
            </tr>
          </tfoot>
        </table>
        <p className="mt-6 text-xs text-lms-faint">
          {t('Paid via')} {payment.gateway} · {t('Reference')}: <span className="lms-num">{payment.transaction_id}</span>
        </p>
      </div>
    </div>
  );
}
